import { hasBFD_Union, getCityName } from "./index";

function setMetaElementContent(name, content) {
  const meta = document.querySelector(`meta[name="${name}"]`);

  if (meta) {
    meta.setAttribute("content", content);
  } else {
    const meta = document.createElement("meta");
    meta.name = name;
    meta.content = content;
    document.getElementsByTagName("head")[0].appendChild(meta);
  }
}

function setDocumentTitleInfo(title, keywords, description) {
  if (hasBFD_Union()) {
    return;
  }

  if (title) {
    document.title = title;
  }

  if (keywords) {
    setMetaElementContent("keywords", keywords);
  }

  if (description) {
    setMetaElementContent("description", description);
  }
}

/**
 *  activity  活动名
 *  city   城市
 *  categoryName  分类名称
 *  goodsName  商品名称
 * 品牌名称 brand
 */
const HASH = {
  "/activity/detail": [
    "东方福利网上海-activity",
    "activity,东方福利网",
    "东方福利网activity，东方福利网助力企业优化员工福利品质，降低采购成本，扩大员工福利选择自由度，提升员工对企业满意度"
  ],
  "/shop/product/list": [
    "东方福利网city-categoryName产品价格/评价/图片",
    "categoryName产品价格,categoryName产品评价,categoryName产品图片,东方福利网",
    "东方福利网city，专业为员工提供categoryName产品评价、图片介绍及价格查询服务，不同品牌和种类可选，满足员工个性化需求"
  ],
  "/shop/product/detail": [
    "东方福利网city-goodsName用券价格/评价/图片",
    "goodsName价格,goodsName评价,goodsName图片,东方福利网",
    "东方福利网city，专业为员工提供goodsName评价、图片介绍及价格查询服务，满足员工个性化需求"
  ],
  "/shop/brand/detail": [
    "东方福利网city-brand门店地址/品牌故事",
    "brand门店地址,brand品牌故事,东方福利网	",
    "东方福利网city，专业为员工提供brand门店地址、品牌故事及价格查询服务，不同品牌和种类可选，满足员工个性化需求"
  ],
  "/shop/brand/newDetail": [
    "东方福利网city-brand门店地址/品牌故事",
    "brand门店地址,brand品牌故事,东方福利网	",
    "东方福利网city，专业为员工提供brand门店地址、品牌故事及价格查询服务，不同品牌和种类可选，满足员工个性化需求"
  ],
  "/shop/birthday": [
    "东方福利网city-员工生日福利",
    "city员工生日福利,东方福利网",
    "东方福利网city，专业为员工提供生日蛋糕预定、电子抵用券兑换服务，不同品牌和种类可选，满足员工个性化需求"
  ],
};

/**
 * 设置爬虫数据
 *
 */
export function setTitleInfo(obj = {}) {
  const { activity, categoryName, brand, goodsName } = obj;
  const cityName = getCityName();
  let pathName = location.pathname;

  if (pathName.includes('/shop/brand/detail')) {
    pathName = '/shop/brand/detail';
  } else if (pathName.includes('/shop/brand/newDetail')) {
    pathName = '/shop/brand/newDetail';
  }
    
  const currentItems = HASH[pathName] || [];
  const list = currentItems.map((element) => {
    let str = element.replace(/city/g, cityName);
    if (activity) {
      str = str.replace(/activity/g, activity);
    }
    if (categoryName) {
      str = str.replace(/categoryName/g, categoryName);
    }

    if (goodsName) {
      str = str.replace(/goodsName/g, goodsName);
    }

    if (brand) {
      str = str.replace(/brand/g, brand);
    }

    return str;
  });

  setTimeout(() => {
    setDocumentTitleInfo(list[0], list[1], list[2]);
  }, 500);
}
